import { withProps, mapProps } from 'recompose'
import { Field } from 'formik'
import { InlineDatePicker } from 'material-ui-pickers'
import moment from 'moment'

const DateField = mapProps(({ form, field, ...props }) => ({
  ...props,
  keyboard: true,
  onlyCalendar: true,
  format: 'DD/MM/YYYY',
  mask: [/\d/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/],
  value: field.value,
  onBlur: () => form.setFieldTouched(field.name, true),
  onChange: value =>
    form.setFieldValue(field.name, moment(value).format('YYYY-MM-DD'))
}))(InlineDatePicker)

export default withProps({ component: DateField })(Field)
